"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetUserTicketDetail = exports.GetUserTicketListWithOrder = exports.GetUserTicketList = exports.DeleteAllUserTicket = exports.DeleteUserTicket = exports.UpdateUserTicket = exports.CreateUserTicket = void 0;

var firestore_1 = require("rxfire/firestore");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var firebase_1 = require("../firebase");

var UserTicketRefPath = function UserTicketRefPath(UserKey) {
  return firebase_1.FirebaseApp.firestore().collection('UserInfo').doc(UserKey).collection('UserTicket');
};

var OrderTransactionRefPath = function OrderTransactionRefPath(userKey) {
  return firebase_1.FirebaseApp.firestore().collection('OrderTransaction');
};

exports.CreateUserTicket = function (UserKey, Data) {
  return rxjs_1.from(UserTicketRefPath(UserKey).add(Data));
};

exports.UpdateUserTicket = function (UserKey, UserTicketKey, Data) {
  return rxjs_1.from(UserTicketRefPath(UserKey).doc(UserTicketKey).set(__assign(__assign({}, Data), {
    UserTicketUpdateTimestamp: firebase_1.FirestoreFieldValue.serverTimestamp()
  }), {
    merge: true
  }));
};

exports.DeleteUserTicket = function (UserKey, UserTicketKey) {
  return rxjs_1.from(UserTicketRefPath(UserKey).doc(UserTicketKey).delete());
};

exports.DeleteAllUserTicket = function (UserKey) {
  return firestore_1.collectionData(UserTicketRefPath(UserKey), 'UserTicketKey').pipe(operators_1.map(function (UserTicketList) {
    var DeleteAllUserTicketBatch = firebase_1.FirebaseApp.firestore().batch();
    UserTicketList.map(function (UserTicketDoc) {
      return DeleteAllUserTicketBatch.delete(UserTicketRefPath(UserKey).doc(UserTicketDoc.UserTicketKey));
    });
    return DeleteAllUserTicketBatch.commit();
  }));
};

exports.GetUserTicketList = function (UserKey) {
  return firestore_1.collectionData(UserTicketRefPath(UserKey).orderBy('UserTicketCreateTimestamp', 'desc'), 'UserTicketKey').pipe(operators_1.take(1));
};

exports.GetUserTicketListWithOrder = function (UserKey) {
  return firestore_1.collectionData(UserTicketRefPath(UserKey).orderBy('UserTicketCreateTimestamp', 'desc'), 'UserTicketKey').pipe(operators_1.flatMap(function (tickets) {
    return __awaiter(void 0, void 0, void 0, function () {
      var myOrdersWithUserInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, Promise.all(tickets.map(function (ticket) {
              return __awaiter(void 0, void 0, void 0, function () {
                var orderInfo;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4, OrderTransactionRefPath(UserKey).doc(ticket.OrderTransactionKey).get().then(function (doc) {
                        var orderDoc = doc.data();
                        return orderDoc;
                      }).catch(function (e) {
                        console.log(e);
                      })];

                    case 1:
                      orderInfo = _a.sent();
                      ;
                      return [2, __assign(__assign({}, ticket), {
                        orderInfo: orderInfo
                      })];
                  }
                });
              });
            }))];

          case 1:
            myOrdersWithUserInfo = _a.sent();
            return [2, myOrdersWithUserInfo];
        }
      });
    });
  }));
};

exports.GetUserTicketDetail = function (UserKey, UserTicketKey) {
  return firestore_1.docData(UserTicketRefPath(UserKey).doc(UserTicketKey), 'UserTicketKey');
};